import React from 'react';

import { useTranslation } from 'client/hooks';

import Icon from '../../../../Icon';

import css from './MicrophoneButton.module.scss';

interface Props {
  isMicMuted: boolean;
}

const MicrophoneButton: React.FC<Props> = (props) => {
  const { isMicMuted } = props;
  const { translate } = useTranslation('actionsPanel');

  return (
    <>
      <div className={css.iconWrapper}>
        <Icon type={isMicMuted ? 'mic-muted-l' : 'mic-unmute-l'} className={css.icon} />
      </div>
      <div className={css.name}>
        {isMicMuted ? translate('btns.speakerMicMutedBtn') : translate('btns.speakerMicUnmutedBtn')}
      </div>
    </>
  );
};

export default MicrophoneButton;
